module.exports = __webpack_public_path__ + "media/images/pic/pigs-28fd9bd31cf1ef449ee6c6d1da9d74ca.jpg";